//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 

import Pristine from 'pristinejs'; 

export default {
    name: "contactusform",
    props:{
      content: Object
    },
    data(){
          return {
            form_sent: false,
            submitted: false,
            valid: true,
            pristine: null,
            pristineConfig: {
                classTo: 'input-group',
                errorClass: 'has-error',
                successClass: 'has-success',
                errorTextParent: 'input-error',
                errorTextTag: 'span',
                errorTextClass: 'text-help'
            }
          }
      },
      mounted(){
            this.pristine = new Pristine(this.$refs.form, this.pristineConfig);    
            this.$refs.form.action = process.env.PRODUCTION_BASE_URL + "/contact";     
            this.$refs.referrer = process.env.FRONTEND_PRODUCTION_BASE_URL + location.href.replace(location.origin,'');

            if (this.$route.hash == '#submitted'){
                this.submitted = true;
            }  
   
      },
      methods:{
          submitForm(e){
            this.valid = this.pristine.validate(); 

            e.preventDefault();
            
            if (this.valid)
            { 
                    let myForm = this.$refs.form;
                    this.form_sent = true;

                    myForm.submit();
                    
            }
            else
            {
                console.log("invalid");
            }
          }
      }
}
